import { LOGOUT } from '../../app/login/duck/types';
import { SET_ONBOARDING_CHECKLIST_SHOWN } from '../types';

const initialState = {
  shortCode: undefined,
  onboardingChecklistShown: true,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_ONBOARDING_CHECKLIST_SHOWN: {
      return {
        ...state,
        onboardingChecklistShown: action.shown,
      };
    }
    case LOGOUT: {
      return initialState;
    }
    default:
      return state;
  }
}
